import { ActivityLogDto } from '../types/activity-log.types';

export class HighCpiConfirmationActivityGenerator {
  constructor(
    private readonly _surveyId: number,
    private readonly _cpi: number | string
  ) {}

  public generate(): ActivityLogDto {
    return {
      eventSource: 'user',
      logMessage: 'CONFIRMED_HIGH_CPI',
      surveyId: this._surveyId,
      metadata: {
        cpi: this._cpi,
      },
    };
  }
}
